module.exports = __webpack_public_path__ + "img/03.a4b2377b.png";